import { observer } from "mobx-react-lite";
import React from "react";
import { Select } from "@frui.ts/bootstrap";
import { Col, Form } from "react-bootstrap";
import FormLabel from "controls/formLabel";
import FormGroup from "controls/formGroup";
import type RoleCreateViewModel from "viewModels/users/roles/roleCreateViewModel";
import type RoleUpdateViewModel from "viewModels/users/roles/detail/roleUpdateViewModel";

export interface RoleFormProps {
  vm: RoleCreateViewModel | RoleUpdateViewModel;
  children?: React.ReactNode;
}

const RoleForm = observer((props: RoleFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="permissionAreaId">
          <FormLabel>{vm.translateAttribute("permissionAreaId")}</FormLabel>
          <Select mode="key" items={vm.permissionAreaOptions} disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="permissionType">
          <FormLabel>{vm.translateAttribute("permissionType")}</FormLabel>
          <Select mode="key" items={vm.permissionTypeOptions} disabled={disabled} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default RoleForm;
